import * as React from 'react';

import {Button} from '../../button/button';

import {getProductItemizedName} from '../helpers';
import type {Product} from '../types';

import styles from './popover-content.module.css';

type Props = {
    selectedCode: string;
    quantity: string;
    productKey: Product;
    requestingCustomPricing: boolean | null | undefined;
    onClickContactOurTeam: () => void | null | undefined;
};

export const PopoverContent = (props: Props) => {
    if (props.selectedCode === 'custom') {
        return props.requestingCustomPricing ? (
            <div>Our team will reach out to you</div>
        ) : (
            <Button
                variant='text-primary'
                onClick={props.onClickContactOurTeam}
                className={styles['contact-team']}
            >
                Contact our team
            </Button>
        );
    } else {
        return `Up to ${props.quantity} ${getProductItemizedName(props.productKey)}`;
    }
};
